import {useEffect, useState} from "react";
import ApiService from "../../core/service/api-service";
import {Select} from "antd";
import { matchesSearch } from "../../core/utils/text-search";

export default function DeviceSelectBox({hospitalId, autoSelect=true, ...props}) {
    const [devices, setDevices] = useState([])
    const [loading, setLoading] = useState(false)

    const getDevices = async () =>
    {
        setLoading(true);
        try {
            let response;
            if (hospitalId) {
                response = await ApiService.Device.GetListByHospital(hospitalId);
            } else {
                response = await ApiService.Device.GetList();
            }
            
            if(response.success)
            {
                setDevices(response.data.map(x => ({
                    ...x,
                    displayName: `${x.name} (${x.aeTitle}) - ${x.hospital?.name}`
                })));

                
                if(autoSelect && response.data.length > 0){
                    props.onChange?.(response.data[0]?.id);
                }
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() =>
    {
        getDevices()
    }, [hospitalId])

    return (
        <>
            <Select
                allowClear
                loading={loading}
                options={devices}
                filterOption={(input, option) => {
                    return matchesSearch(option?.displayName, input)
                }}
                fieldNames={{
                    label: 'displayName',
                    value: 'id'
                }}
                {...props}
            />
        </>
    )
}
